import FuelStation from '../../models/configs/fuelStations.model'

let storeContent = utils.generateStore({
   FuelStation,
   stations: [],
   showUpload: false
})

export default {
   state: {
      ...storeContent.state
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addStation(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               await api.fetchEndpointSecure({
                  resource: "registration",
                  action: "add:station",
                  data: {
                     name: data.name,
                     company: data.company,
                     county: data.county.name,
                  },
                  meta_data: {}
               })

               await ctx.dispatch('fetchStations')
               $notify('success', 'Station Created', `Station ${data.name} successfully created.`)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async fetchStations(ctx) {
         try {
            ctx.commit('show', false)
            let res = await api.fetchEndpointSecure({
               resource: "registration",
               action: "get:stations",
               data: {},
               meta_data: {}
            })
            ctx.commit('stations', res.result.stations)

            EventBus.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
      async uploadStations(ctx,payload){
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               console.log(data.stations[0])
               let bodyFormData = new FormData()
               bodyFormData.append('csv',data.stations[0]);
               bodyFormData.append('resource','registration');
               bodyFormData.append('action','add:multiple_stations');
               bodyFormData.append('file_action','excel_key');

               ctx.commit('showUpload',false)
               let res = await api.upload(api.parseRoute('/upload'),bodyFormData,'fuel_stations');
               await ctx.dispatch('fetchStations')
               $notify('success', 'Uploaded Fuel Stations', res.result.msg,10)
            }
            ctx.commit('loading', false)
         }catch(err){
            ctx.commit('loading', false)
            console.log(err)
            $notify('error', 'Upload Fail', `Upload for ${'fuel_stations'} failed. Please Try again Later.`,15)
            throw err;
         }
      },
      async fetchFormData(ctx) {
         try {
            // Fetch User Groups
            let res = await api.fetchEndpointSecure({
               resource: "registration",
               action: "get:counties",
               data: {},
               meta_data: {}
            })
            let form = utils.appendSelectData({
               form: FuelStation.forms.add_fuel_station,
               model: 'county',
               label: 'name',
               data: res.result.counties
            })

            if (form) {
               let Model = ctx.getters.FuelStation
               Model.forms.add_fuel_station = form
               ctx.commit('FuelStation', Model)
            }
         } catch (err) {
            throw err
         }
      }
   }
};